import { Card, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { Clock } from 'lucide-react'
import { useEffect } from 'react'
import logoBay211 from '@/assets/logo-211bayarea.svg'
import logoOneDegree from '@/assets/logo-one-degree.png'
import logoCareerOneStop from '@/assets/logo-careeromestop.png'
// import DORA from '@/assets/dora.svg'
// import ES from '@/assets/emploi-store.svg'
// import IM from '@/assets/imilo.png'

// function Connected() {
//   return (
//     <div className="text-primary my-auto flex items-center justify-end text-xs">
//       <div>Activated</div>
//       <CheckCircle className="text-primary-500 ml-1 h-4 w-4" />
//     </div>
//   )
// }

// function Disconnected() {
//   return (
//     <div className="text-primary my-auto flex items-center justify-end text-xs">
//       <div>Deactivated</div>
//       <CircleOff className="ml-1 h-4 w-4 text-gray-500" />
//     </div>
//   )
// }

function ComingSoon() {
  return (
    <div className="text-primary my-auto flex items-center justify-end text-xs">
      <div>Coming Soon</div>
      <Clock className="text-primary ml-1 h-4 w-4" />
    </div>
  )
}

function SourceItem({ children }: { children: React.ReactNode }) {
  return (
    <li className="flex h-20 max-h-20 items-center justify-between gap-x-2">
      {children}
    </li>
  )
}

function CommonSource({ source }: { source: string }) {
  switch (source) {
    case '211':
      return (
        <div className="m-4 rounded border p-4">
          <SourceItem>
            <img src={logoBay211} alt="im" className="h-12" />
            <ComingSoon />
          </SourceItem>
        </div>
      )
    case '1DEGREE':
      return (
        <div className="m-4 rounded border p-4">
          <SourceItem>
            <img src={logoOneDegree} alt="im" className="h-12" />
            <div>One Degree</div>
            <ComingSoon />
          </SourceItem>
        </div>
      )
    case 'CAREERONESTOP':
      return (
        <div className="m-4 rounded border p-4">
          <SourceItem>
            <img src={logoCareerOneStop} alt="im" className="h-12" />
            <div className="text-blue-400">
              <span className="text-red-600">career</span>onestop
            </div>
            <ComingSoon />
          </SourceItem>
        </div>
      )
  }
  return null
}

export function CommonSources({ commonSources }: { commonSources: string[] }) {
  // FIXME JDO i18n
  return (
    <div className="flex flex-1 flex-col gap-2">
      <Card className="flex flex-1 flex-col overflow-hidden">
        <CardHeader>
          <CardTitle>Sources</CardTitle>
          <CardDescription>
            CaseAI can use this common sources to improve action plans
          </CardDescription>
        </CardHeader>
        {commonSources.map((source) => (
          <CommonSource source={source} />
        ))}
        <ul className="m-4">
          {/*URLs*/}
          {/*<div className="m-4 rounded border p-4">*/}
          {/*  <SourceItem>*/}
          {/*    <span className="text-xs">https://everything.is.awesome.com</span>*/}
          {/*    <span className="text-xs">Last synchronization 2 hours ago</span>*/}
          {/*    <span className="text-xs">34 resources</span>*/}
          {/*    <Disconnected />*/}
          {/*  </SourceItem>*/}
          {/*</div>*/}
        </ul>
      </Card>
    </div>
  )
}

export function Documents() {
  // Define datasets for different agencies - using exact names from the agency list
  const documentsByAgency = {
    // Custom document sets for specific agencies
    Paris: [
      { name: 'integration_nouveaux.pdf', date: '11/03/2025', size: '1.2 Mo' },
      { name: 'recommandations.pdf', date: '02/04/2025', size: '842 Ko' },
      { name: 'procedures.pdf', date: '05/04/2025', size: '2.3 Mo' },
      { name: 'materiel_formation.pdf', date: '08/04/2025', size: '4.5 Mo' },
    ],
    LILLE: [
      { name: 'guide_utilisateur.pdf', date: '15/03/2025', size: '3.1 Mo' },
      { name: 'formation_interne.pdf', date: '21/03/2025', size: '1.8 Mo' },
      { name: 'emploi_jeunes.pdf', date: '01/04/2025', size: '725 Ko' },
      { name: 'procedures_locales.pdf', date: '07/04/2025', size: '1.5 Mo' },
      { name: 'partenaires_locaux.pdf', date: '09/04/2025', size: '950 Ko' },
    ],
    MARSEILLE: [
      { name: 'guide_regional.pdf', date: '18/03/2025', size: '2.7 Mo' },
      {
        name: 'formations_disponibles.pdf',
        date: '25/03/2025',
        size: '1.3 Mo',
      },
      { name: 'programmes_insertion.pdf', date: '03/04/2025', size: '680 Ko' },
    ],
    LYON: [
      { name: 'guide_regional_aura.pdf', date: '20/03/2025', size: '3.4 Mo' },
      { name: 'dispositifs_locaux.pdf', date: '27/03/2025', size: '950 Ko' },
      { name: 'partenaires_rhone.pdf', date: '04/04/2025', size: '1.1 Mo' },
      { name: 'contrats_aides.pdf', date: '07/04/2025', size: '540 Ko' },
    ],
    NANTES: [
      { name: 'guide_pays_loire.pdf', date: '15/03/2025', size: '2.9 Mo' },
      { name: 'dispositifs_insertion.pdf', date: '22/03/2025', size: '1.7 Mo' },
      {
        name: 'partenaires_loire_atlantique.pdf',
        date: '01/04/2025',
        size: '890 Ko',
      },
      { name: 'offres_emploi_locales.pdf', date: '08/04/2025', size: '1.3 Mo' },
      {
        name: 'formations_disponibles.pdf',
        date: '06/04/2025',
        size: '2.1 Mo',
      },
    ],
    // Default document set for all other agencies
    default: [
      { name: 'procedures_nationales.pdf', date: '10/03/2025', size: '1.6 Mo' },
      { name: 'guide_conseiller.pdf', date: '01/04/2025', size: '2.8 Mo' },
      {
        name: 'formulaires_administratifs.pdf',
        date: '05/04/2025',
        size: '950 Ko',
      },
    ],
  }

  // Set default selected agency - use a Nantes agency
  const defaultAgency = 'NANTES CENTRE'
  // const [selectedAgency, setSelectedAgency] = useState<string>(defaultAgency)

  // Initialize with our known agencies
  useEffect(() => {
    // The agency list doesn't natively have our exact keys, so we're
    // pre-selecting one of our known dataset keys on component mount
    console.log('Setting default agency:', defaultAgency)
  }, [])

  return (
    <div className="flex flex-1 flex-col gap-2">
      <Card className="flex flex-1 flex-col overflow-hidden">
        <CardHeader>
          <CardTitle>Documents</CardTitle>
          <CardDescription>
            Consultez les documents disponibles par agence
          </CardDescription>
        </CardHeader>
        <div className="mb-4 mt-2 px-4">
          {/*<AgencySelector*/}
          {/*  selectedAgency={selectedAgency}*/}
          {/*  setSelectedAgency={handleAgencyChange}*/}
          {/*  label="Choisir une agence :"*/}
          {/*  placeholder="Sélectionner une agence"*/}
          {/*/>*/}
        </div>
        <div className="p-4">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-800">
              Ressources Internes
            </h3>
            <button className="bg-primary-50 hover:bg-primary-100 text-primary-600 flex items-center rounded-full px-3 py-1 text-xs">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1 h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Nouveau document
            </button>
          </div>
          <div className="overflow-hidden rounded-lg border border-gray-200">
            <div className="grid grid-cols-12 bg-gray-50 px-4 py-2 text-xs font-medium text-gray-500">
              <div className="col-span-6">Nom</div>
              <div className="col-span-3">Date de modification</div>
              <div className="col-span-2 text-right">Taille</div>
              <div className="col-span-1"></div>
            </div>
            {documentsByAgency['Paris'].map((file, index) => (
              <div
                key={file.name}
                className={`group grid grid-cols-12 items-center px-4 py-3 transition-colors hover:bg-gray-50 ${
                  index !== documentsByAgency['Paris'].length - 1
                    ? 'border-b border-gray-200'
                    : ''
                }`}
              >
                <div className="col-span-6 flex items-center">
                  <div className="mr-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <span className="truncate text-sm font-medium text-gray-900">
                    {file.name}
                  </span>
                </div>
                <div className="col-span-3 text-sm text-gray-500">
                  {file.date}
                </div>
                <div className="col-span-2 text-right text-sm text-gray-500">
                  {file.size}
                </div>
                <div className="col-span-1 flex justify-end">
                  <button className="rounded p-1 opacity-0 transition-opacity hover:bg-gray-200 group-hover:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  )
}
